// Overlay raster "semplici" v2 — registro DICHIARATIVO di tutti gli overlay
// WMS/WMTS/imageOverlay della v1 SENZA timeline (attiva/disattiva a toggle).
// Sorgente di verità: ../../assets/js/map-layers.js (valori portati 1:1:
// layer, versione WMS, opacity, TIME). Etichette/gruppi da index.php v1.
//
// Pattern (vedi satellite.js/radar.js):
//  - WMS  → raster source con tile template GetMap 256px e {bbox-epsg-3857}
//           (v1.3.0 → crs=, v1.1.1 → srs=)
//  - WMTS → template REST (GIBS) o KVP GetTile (CMEMS); {time} risolto al
//           momento dell'attivazione (make() è richiamata ad OGNI toggle-on)
//  - imageOverlay → source type 'image' con coordinates dai bounds Leaflet
//  - beforeId: sotto 'ws-stations-symbols' se esiste

const SATELLITE_API = 'https://api.weathersicily.it/v1/satellite';
const EFFIS_WMS = 'https://maps.effis.emergency.copernicus.eu/gwis';
const EMODNET_WMS = 'https://ows.emodnet-bathymetry.eu/wms';
const GIBS_BASE = 'https://gibs.earthdata.nasa.gov/wmts/epsg3857/best';
const CMEMS_WMTS = 'https://wmts.marine.copernicus.eu/teroWmts';

// FWI WSLam 2 km (v1: WS_FWI_OVERLAY/WS_FWI_BOUNDS) + fallback EFFIS ecmwf.fwi
const FWI_OVERLAY = 'https://climate.weathersicily.it/atlas/overlay.php?type=fwi';
const FWI_BOUNDS = [[36.40, 12.30], [38.55, 15.75]]; // [[S,W],[N,E]]
// Risorsa solare CM SAF SARAH (v1: WS_SOLAR_BASE/WS_SOLAR_BOUNDS)
const SOLAR_BASE = 'https://climate.weathersicily.it/atlas/overlay.php?type=solar&mode=';
const SOLAR_BOUNDS = [[35.50, 11.50], [39.00, 16.00]]; // [[S,W],[N,E]]
const SICILY_SOIL_BOUNDS = [[35.9, 11.7], [39.0, 16.2]];

// ---------------------------------------------------------------------------
// Helper TIME / URL (ricalcolati ad ogni attivazione, MAI hardcodati)
// ---------------------------------------------------------------------------

// Data UTC 'YYYY-MM-DD' N giorni fa (port di wsGibsDate, map-layers.js:922)
function daysAgoDate(daysAgo) {
    return new Date(Date.now() - daysAgo * 86400000).toISOString().slice(0, 10);
}

// Cache-bust giornaliero ?d=YYYYMMDD in ora LOCALE (port v1, map-layers.js:322)
function localDayStamp() {
    const d = new Date();
    return '' + d.getFullYear() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
}

function latestSatelliteTime() {
    const d = new Date(Date.now() - 50 * 60000);
    d.setUTCMinutes(d.getUTCMinutes() - (d.getUTCMinutes() % 10), 0, 0);
    return d.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

function satelliteTiles(layer) {
    return SATELLITE_API + '/tile?layer=' + encodeURIComponent(layer)
        + '&time=' + encodeURIComponent(latestSatelliteTime())
        + '&size=256&bbox={bbox-epsg-3857}';
}

// Template GetMap tile 256px con {bbox-epsg-3857}; 1.3.0→crs, 1.1.1→srs.
function wmsTiles(base, { layers, styles = '', version = '1.3.0', time = null }) {
    const sep = base.includes('?') ? '&' : '?';
    const srsKey = (version === '1.1.1') ? 'srs' : 'crs';
    let url = base + sep + 'service=WMS&request=GetMap'
        + '&layers=' + encodeURIComponent(layers)
        + '&styles=' + encodeURIComponent(styles)
        + '&format=image%2Fpng&transparent=true'
        + '&version=' + version
        + '&' + srsKey + '=EPSG%3A3857'
        + '&width=256&height=256&bbox={bbox-epsg-3857}';
    if (time) url += '&time=' + encodeURIComponent(time);
    return url;
}

// GIBS WMTS REST (port di wsGibsUrl, map-layers.js:926)
function gibsUrl(layer, tms, ext, daysAgo) {
    return GIBS_BASE + '/' + layer + '/default/' + daysAgoDate(daysAgo) + '/' + tms + '/{z}/{y}/{x}.' + ext;
}

// CMEMS WMTS KVP GetTile (port di wsCmemsUrl, map-layers.js:501)
function cmemsUrl(layerId, style) {
    return CMEMS_WMTS + '?service=WMTS&request=GetTile&version=1.0.0'
        + '&layer=' + encodeURIComponent(layerId)
        + '&style=' + encodeURIComponent(style)
        + '&tilematrixset=EPSG:3857&TileMatrix={z}&TileRow={y}&TileCol={x}&format=image/png';
}

// Bounds Leaflet [[S,W],[N,E]] → coordinates MapLibre [TL,TR,BR,BL]
function boundsToCoords([[s, w], [n, e]]) {
    return [[w, n], [e, n], [e, s], [w, s]];
}

// ---------------------------------------------------------------------------
// Costruttori dichiarativi { sources:{...}, layers:[...] }
// ---------------------------------------------------------------------------

function ovlIds(key) {
    return { src: 'ws-ovl-' + key + '-src', lyr: 'ws-ovl-' + key };
}

function rasterSpec(key, tiles, opacity, maxzoom) {
    const { src, lyr } = ovlIds(key);
    const source = { type: 'raster', tiles: [tiles], tileSize: 256 };
    if (maxzoom) source.maxzoom = maxzoom; // zoom nativo: oltre si fa overzoom
    return {
        sources: { [src]: source },
        layers: [{ id: lyr, type: 'raster', source: src, paint: { 'raster-opacity': opacity } }],
    };
}

function imageSpec(key, url, bounds, opacity) {
    const { src, lyr } = ovlIds(key);
    return {
        sources: { [src]: { type: 'image', url, coordinates: boundsToCoords(bounds) } },
        layers: [{ id: lyr, type: 'raster', source: src, paint: { 'raster-opacity': opacity, 'raster-fade-duration': 0 } }],
    };
}

// Modo risorsa solare ('year' | 'recent'), persistito come in v1 (wsSolarMode)
let solarMode = (function () {
    try { return localStorage.getItem('wsSolarMode') || 'year'; } catch (e) { return 'year'; }
})();

// ---------------------------------------------------------------------------
// REGISTRO — key → { label (v1 index.php), group, make() [, fallback()] }
// ---------------------------------------------------------------------------

export const OVERLAY_DEFS = {
    // ===== 🌧️ Nowcast & cielo ==============================================
    // (2026-07-03: rimossi come in v1 dpcSri/dpcSrt, msgConv, msgAir, gii, imerg)
    dust: {
        label: 'Polveri sahariane 🟤', group: 'nowcast',
        // v1: msg_fes:rgb_dust, v1.3.0, opacity 0.82 (ultimo frame, no TIME)
        make: () => rasterSpec('dust', satelliteTiles('dust'), 0.82),
    },

    // ===== 📊 Campi & analisi ===============================================
    solar: {
        label: 'Energia solare (fotovoltaico) ☀️', group: 'fields',
        // v1: imageOverlay solar_year.png|solar_recent.png, bounds
        //     [[35.5,11.5],[39,16]], opacity 0.78, ?d=YYYYMMDD; default 'year'
        make: () => imageSpec('solar',
            SOLAR_BASE + (solarMode === 'recent' ? 'recent' : 'year') + '&d=' + localDayStamp(),
            SOLAR_BOUNDS, 0.78),
    },

    // ===== ⚠️ Rischi & allerte ==============================================
    fwi: {
        label: 'Pericolo incendi (FWI) 🔥📈', group: 'risks',
        // v1: imageOverlay fwi_latest.png?d=YYYYMMDD, bounds
        //     [[36.40,12.30],[38.55,15.75]], opacity 0.62
        make: () => imageSpec('fwi', FWI_OVERLAY + '&d=' + localDayStamp(), FWI_BOUNDS, 0.62),
        // v1: on('error') → ripiega sul WMS EFFIS ecmwf.fwi, opacity 0.55
        fallback: () => rasterSpec('fwi', wmsTiles(EFFIS_WMS, { layers: 'ecmwf.fwi' }), 0.55),
    },
    soilMoisture: {
        label: 'Umidità superficiale del suolo 💧🛰️', group: 'risks',
        // NASA SMAP L4, 9 km; data e limiti in /cambiamenti/#soil.
        make: () => imageSpec('soilMoisture',
            '/assets/data/soil-moisture-latest.png?v=2&d=' + localDayStamp(),
            SICILY_SOIL_BOUNDS, 0.86),
    },
    droughtRaster: {
        label: 'Siccità regionale · Copernicus EDO 🌵', group: 'risks',
        // Pixel CDI originali, non interpolazione dei punti comunali.
        make: () => imageSpec('droughtRaster',
            '/assets/data/edo-drought-latest.png?d=' + localDayStamp(),
            SICILY_SOIL_BOUNDS, 0.95),
    },
    // (2026-07-03: rimossi come in v1 frp, burntAreas, so2)

    // ===== 🌊 Mare & acque (CMEMS WMTS, v1: WS_CMEMS_LAYERS, maxNativeZoom 10)
    waves: {
        label: 'Onde (modello) 🌊📈', group: 'sea',
        make: () => rasterSpec('waves', cmemsUrl(
            'MEDSEA_ANALYSISFORECAST_WAV_006_017/cmems_mod_med_wav_anfc_4.2km_PT1H-i_202311/VHM0',
            'cmap:viridis'), 0.80, 10),
    },
    sst: {
        label: 'Temperatura mare 🌡️🌊', group: 'sea',
        make: () => rasterSpec('sst', cmemsUrl(
            'SST_MED_SST_L4_NRT_OBSERVATIONS_010_004/SST_MED_SST_L4_NRT_OBSERVATIONS_010_004_a_V2_202311/analysed_sst',
            'cmap:thermal'), 0.78, 10),
    },
    sstAnom: {
        label: 'Anomalia SST 🔥🌊', group: 'sea',
        make: () => rasterSpec('sstAnom', cmemsUrl(
            'SST_MED_SST_L4_NRT_OBSERVATIONS_010_004/SST_MED_SSTA_L4_NRT_OBSERVATIONS_010_004_b_202511/sst_anomaly',
            'cmap:balance,range:-3/3'), 0.80, 10),
    },
    // (2026-07-03: rimossi come in v1 currents, chl, sla, ph, o2)

    // ===== 🗺️ Mappa & extra =================================================
    // 'lst' (Temp. suolo LST satellite) rimosso 2026-07-03 su richiesta Giuseppe.
    snow: {
        label: 'Neve al suolo ❄️🛰️', group: 'extra',
        // v1 GIBS: MODIS_Terra_NDSI_Snow_Cover, Level8, time now−2gg, op 0.85
        make: () => rasterSpec('snow',
            gibsUrl('MODIS_Terra_NDSI_Snow_Cover', 'GoogleMapsCompatible_Level8', 'png', 2), 0.85, 8),
    },
    // (2026-07-03: rimossi come in v1 ndvi, aodObs)
    bathymetry: {
        label: 'Profondità mare 🌊⬇️', group: 'extra',
        // v1: EMODnet emodnet:mean_multicolour, v1.3.0, opacity 0.72
        make: () => rasterSpec('bathymetry', wmsTiles(EMODNET_WMS, { layers: 'emodnet:mean_multicolour' }), 0.72),
    },
};

// ---------------------------------------------------------------------------
// Motore attivazione
// ---------------------------------------------------------------------------

const state = {
    map: null,
    active: new Map(), // key → { spec, offError? }
};

function stationsBeforeId() {
    // gli overlay stanno SOTTO i simboli stazione (se già presenti)
    return state.map.getLayer('ws-stations-symbols') ? 'ws-stations-symbols' : undefined;
}

function addSpec(spec) {
    const map = state.map;
    for (const [id, src] of Object.entries(spec.sources)) {
        if (!map.getSource(id)) map.addSource(id, src);
    }
    const before = stationsBeforeId();
    for (const lyr of spec.layers) {
        if (!map.getLayer(lyr.id)) map.addLayer(lyr, before);
    }
}

function removeSpec(spec) {
    const map = state.map;
    for (const lyr of spec.layers) {
        try { if (map.getLayer(lyr.id)) map.removeLayer(lyr.id); } catch (e) {}
    }
    for (const id of Object.keys(spec.sources)) {
        try { if (map.getSource(id)) map.removeSource(id); } catch (e) {}
    }
}

// Replica della logica on-error v1 (FWI): se la source primaria fallisce
// (es. overlay PNG 404), si smonta e si monta il fallback dichiarato.
function armFallback(key, def, entry) {
    const map = state.map;
    const srcIds = Object.keys(entry.spec.sources);
    const onErr = (e) => {
        if (!e || !e.sourceId || !srcIds.includes(e.sourceId)) return;
        map.off('error', onErr);
        entry.offError = null;
        if (state.active.get(key) !== entry) return; // nel frattempo spento
        removeSpec(entry.spec);
        entry.spec = def.fallback();
        addSpec(entry.spec);
    };
    map.on('error', onErr);
    entry.offError = () => map.off('error', onErr);
}

export function initOverlays(map) {
    state.map = map;
    initFeatureInfo(map);
}

// ---------------------------------------------------------------------------
// GetFeatureInfo — click → valore nel punto per gli overlay marini attivi
// (port di wsQueryCmems/wsQueryBathymetry, map-layers.js:432-491). Interroga
// SOLO gli overlay accesi; un click su una stazione NON apre questo popup.
// ---------------------------------------------------------------------------
const CMEMS_GFI = {
    waves:   { id: 'MEDSEA_ANALYSISFORECAST_WAV_006_017/cmems_mod_med_wav_anfc_4.2km_PT1H-i_202311/VHM0', style: 'cmap:viridis', label: 'Onde (alt. significativa)', unit: 'm' },
    sst:     { id: 'SST_MED_SST_L4_NRT_OBSERVATIONS_010_004/SST_MED_SST_L4_NRT_OBSERVATIONS_010_004_a_V2_202311/analysed_sst', style: 'cmap:thermal', label: 'Temperatura mare (SST)', unit: '°C' },
    sstAnom: { id: 'SST_MED_SST_L4_NRT_OBSERVATIONS_010_004/SST_MED_SSTA_L4_NRT_OBSERVATIONS_010_004_b_202511/sst_anomaly', style: 'cmap:balance,range:-3/3', label: 'Anomalia SST', unit: '°C' },
};

function lonLatToTile(lon, lat, z) {
    const n = Math.pow(2, z);
    const x = (lon + 180) / 360 * n;
    const latRad = lat * Math.PI / 180;
    const y = (1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2 * n;
    const col = Math.floor(x), row = Math.floor(y);
    return { col, row, i: Math.floor((x - col) * 256), j: Math.floor((y - row) * 256) };
}

async function queryCmems(key, lng, lat, z) {
    const c = CMEMS_GFI[key];
    const t = lonLatToTile(lng, lat, z);
    const url = CMEMS_WMTS + '?service=WMTS&request=GetFeatureInfo&version=1.0.0'
        + '&layer=' + encodeURIComponent(c.id) + '&style=' + encodeURIComponent(c.style)
        + '&tilematrixset=EPSG:3857&TileMatrix=' + z + '&TileRow=' + t.row + '&TileCol=' + t.col
        + '&I=' + t.i + '&J=' + t.j + '&infoformat=application/json';
    const res = await fetch(url, { cache: 'no-store', credentials: 'omit' });
    const p = (((await res.json()).features || [])[0] || {}).properties || {};
    let v = p.value;
    if (v === null || v === undefined || !Number.isFinite(Number(v))) return null;
    v = Number(v);
    let unit = c.unit;
    if (String(p.units || '').toLowerCase() === 'kelvin') { v = v - 273.15; unit = '°C'; }
    const dec = Math.abs(v) < 10 ? 2 : 1;
    return { label: c.label, text: v.toFixed(dec) + (unit ? ' ' + unit : '') };
}

async function queryBathymetry(lng, lat) {
    const d = 0.02;
    // WMS 1.3.0 EPSG:4326 = ordine lat,lon nel bbox (come la v1)
    const url = EMODNET_WMS + '?service=WMS&version=1.3.0&request=GetFeatureInfo'
        + '&layers=emodnet:mean&query_layers=emodnet:mean&crs=EPSG:4326'
        + '&bbox=' + [lat - d, lng - d, lat + d, lng + d].join(',')
        + '&width=101&height=101&i=50&j=50&info_format=application/json';
    const res = await fetch(url, { cache: 'no-store', credentials: 'omit' });
    const p = (((await res.json()).features || [])[0] || {}).properties || {};
    const depth = Number(p.Depth ?? p.depth ?? p.mean);
    if (!Number.isFinite(depth)) return null;
    return { label: 'Profondità mare', text: Math.abs(Math.round(depth)) + ' m' };
}

// --- FWI click→valore: campiona il grid numerico (nostro WSLam 2km) ----------
// Il PNG overlay dà solo la CLASSE-colore; per il NUMERO campioniamo un grid
// compatto pre-calcolato same-origin (export_fwi_overlay.py → api/data/fwi_grid.json).
// Caricato una volta all'accensione del layer, ricampionato ad ogni click.
let _fwiGrid = null, _fwiGridP = null;
function loadFwiGrid() {
    if (_fwiGrid) return Promise.resolve(_fwiGrid);
    if (_fwiGridP) return _fwiGridP;
    _fwiGridP = fetch('/api/data/fwi_grid.json?d=' + localDayStamp(), { cache: 'no-store' })
        .then(r => r.ok ? r.json() : null)
        .then(g => { _fwiGrid = (g && Array.isArray(g.values)) ? g : null; _fwiGridP = null; return _fwiGrid; })
        .catch(() => { _fwiGridP = null; return null; });
    return _fwiGridP;
}
function classifyFwi(v, classes) {
    let out = null;
    for (const c of (classes || [])) if (v >= c.min) out = c;
    return out; // {label, color, min} o null
}
async function queryFwi(lng, lat) {
    const g = await loadFwiGrid();
    if (!g) return null;
    const [[s, w], [n, e]] = g.bounds;
    if (lng < w || lng > e || lat < s || lat > n) return null;
    // riga 0 = nord, col 0 = ovest; indici nearest sul nodo di griglia
    const fx = (lng - w) / (e - w) * (g.nx - 1);
    const fy = (n - lat) / (n - s) * (g.ny - 1);
    const ix = Math.round(fx), iy = Math.round(fy);
    if (ix < 0 || ix >= g.nx || iy < 0 || iy >= g.ny) return null;
    const v = g.values[iy * g.nx + ix];
    if (v == null || v < 0) return null;         // -1 = mare/no-dato
    const cls = classifyFwi(v, g.classes);
    const chip = cls ? ` · <span style="color:${cls.color};font-weight:800">${cls.label}</span>` : '';
    return { label: '🔥 Pericolo incendi (FWI)', text: `${v}${chip}` };
}

function initFeatureInfo(map) {
    let popup = null;
    map.on('click', async (e) => {
        // un click su una stazione apre la scheda, non questo popup
        if (map.getLayer('ws-stations-symbols')) {
            const hit = map.queryRenderedFeatures(e.point, { layers: ['ws-stations-symbols'] });
            if (hit && hit.length) return;
        }
        const z = Math.max(3, Math.min(10, Math.round(map.getZoom())));
        const { lng, lat } = e.lngLat;
        const tasks = [];
        for (const key of Object.keys(CMEMS_GFI)) if (state.active.has(key)) tasks.push(queryCmems(key, lng, lat, z));
        if (state.active.has('bathymetry')) tasks.push(queryBathymetry(lng, lat));
        if (state.active.has('fwi')) tasks.push(queryFwi(lng, lat));
        if (!tasks.length) return;
        const out = (await Promise.all(tasks.map(t => t.catch(() => null)))).filter(Boolean);
        if (!out.length) return;
        const html = '<div class="ws-query-popup__card"><div class="ws-query-popup__head">📍 In questo punto</div>'
            + out.map(o => `<div class="ws-query-popup__row"><span>${o.label}</span><b>${o.text}</b></div>`).join('')
            + '</div>';
        if (popup) popup.remove();
        popup = new maplibregl.Popup({ className: 'wsv2-tooltip-shell ws-query-popup', maxWidth: '260px', offset: 8 })
            .setLngLat(e.lngLat).setHTML(html).addTo(map);
    });
}

export function setOverlayEnabled(key, on) {
    const def = OVERLAY_DEFS[key];
    if (!def || !state.map) return false;
    const cur = state.active.get(key);
    if (on && !cur) {
        // make() qui → i TIME dinamici (IMERG/SO2/GIBS, cache-bust FWI/solare)
        // sono ricalcolati ad OGNI attivazione
        const entry = { spec: def.make(), offError: null };
        addSpec(entry.spec);
        if (def.fallback) armFallback(key, def, entry);
        state.active.set(key, entry);
        if (key === 'fwi') loadFwiGrid();   // prefetch grid numerico per il click→valore
        return true;
    }
    if (!on && cur) {
        if (cur.offError) cur.offError();
        removeSpec(cur.spec);
        state.active.delete(key);
    }
    return true;
}
